import { CalendarDate } from "../../../api/backend/backend-api"

interface Time {
  hour: number
  minute: number
}

interface DateRef {
  day: number
  month: number
  year: number
}

export const formatTime = (input: Time) =>
  `${input.hour.toString().padStart(2, "0")}:${input.minute
    .toString()
    .padStart(2, "0")}`

export const formatItaDate = (input: DateRef) =>
  [
    input.day.toString().padStart(2, "0"),
    input.month.toString().padStart(2, "0"),
    input.year.toString().padStart(2, "0"),
  ].join("/")

export const calendarDateToString = (value: CalendarDate) =>
  `${value.year}-${value.month
    .toString()
    .padStart(2, "0")}-${value.day.toString().padStart(2, "0")}`

export const parseCalendarDate = (value: string): CalendarDate => ({
  day: parseInt(value.split("-")[2]),
  month: parseInt(value.split("-")[1]),
  year: parseInt(value.split("-")[0]),
})
